import { openAjaxModal } from '../shared/ajax-modal-loader.js';
import { initCreditCardEntry } from '../components/credit-card-entry.js';

import { setOpenPaymentAddConfig, getOpenPaymentAddConfig, opCfg, opHasPrefilledMember, opIsMemberSession, opMemberUserId } from './open-credit-add-modal/config.js';
import { opModal, openPaymentSelectedUserId } from './open-credit-add-modal/dom.js';
import { registerOpenPaymentDafCardTypeHandler } from './open-credit-add-modal/daf-card-type.js';
import { resetSavedPaymentsState } from './open-credit-add-modal/saved-cards.js';
import {
    toggleOpenPaymentLayout,
    syncOpenPaymentForceSurchargeBanner,
    hideOpenPaymentAjaxMsg,
    syncOpenPaymentCardChoicePills,
    seedOpenPaymentSavedPaymentsFromConfig,
    closeOpenPaymentModal,
} from './open-credit-add-modal/ui-state.js';
import { openPaymentInitDatepicker, openPaymentApplyKioskInputMasks } from './open-credit-add-modal/validation.js';
import { bindOpenPaymentAddModalEvents, bindOpenPaymentAddModalDocumentHandlers } from './open-credit-add-modal/events.js';
import { bindOpenPaymentAddModalSubmitHandler } from './open-credit-add-modal/submit.js';

export { setOpenPaymentAddConfig, getOpenPaymentAddConfig, closeOpenPaymentModal };

let initialized = false;

export function wireUp() {
    resetSavedPaymentsState();
    if (!$('#addOpenPaymentModal').length) {
        return;
    }
    openPaymentInitDatepicker();
    if (!opCfg().coverSurchargeOn) {
        opModal().find('.surcharge_row').hide();
    } else {
        opModal().find('.surcharge_row').show();
    }
    if (opHasPrefilledMember() || opIsMemberSession()) {
        const muid = opMemberUserId() || openPaymentSelectedUserId();
        if (muid) {
            opModal().find('#open_payment_user_id').val(String(muid));
        }
        seedOpenPaymentSavedPaymentsFromConfig();
    }
    toggleOpenPaymentLayout();
    syncOpenPaymentForceSurchargeBanner();
    openPaymentApplyKioskInputMasks();
    hideOpenPaymentAjaxMsg();
    syncOpenPaymentCardChoicePills();
}

function readOpenPaymentAddConfigFromContainer($container) {
    const $cfg = $container.find('#open-payment-add-config-json');
    if (!$cfg.length) {
        setOpenPaymentAddConfig({});
        return true;
    }
    try {
        const raw = $cfg.is('textarea') ? $cfg.val() : $cfg.text();
        setOpenPaymentAddConfig(JSON.parse(raw || '{}'));
        return true;
    } catch (e) {
        console.error(e);
        setOpenPaymentAddConfig({});
        return false;
    }
}

export function openOpenCreditAddModal($container, options) {
    openAjaxModal($container, {
        url: options.url,
        data: options.data,
        templateId: 'open-credit-add-loading-shell-template',
        missingTemplateMessage: 'Add funds is not available on this page. Please refresh and try again.',
        loadErrorMessage: 'Unable to load add funds form.',
        afterFill: function ($filledContainer) {
            if (!readOpenPaymentAddConfigFromContainer($filledContainer)) {
                return false;
            }
            wireUp();
            return true;
        },
        onReady: options.onReady,
        onError: options.onError,
        onCancel: options.onCancel,
    });
}

export function init() {
    if (initialized) {
        return;
    }
    initialized = true;
    registerOpenPaymentDafCardTypeHandler();
    initCreditCardEntry();
    bindOpenPaymentAddModalEvents();
    bindOpenPaymentAddModalDocumentHandlers();
    bindOpenPaymentAddModalSubmitHandler();
    if ($('#addOpenPaymentModal').length) {
        wireUp();
    }
}
